module.exports = __webpack_public_path__ + "img/metal_e@2x.c1c838f0.png";